import React, { lazy } from 'react';
import ForgetPassword from 'granite-admin/pages/forgotpassword';
import Login from 'granite-admin/pages/login';
import Sso from 'granite-admin/pages/sso';
import OnBoarding from 'granite-admin/pages/onBoarding';
import Register from 'granite-admin/pages/register';
import VerifyAccount from 'granite-admin/pages/verifyAccount';
import PrivacyPolicy from 'granite-admin/pages/privacyPolicy';
import Terms from 'granite-admin/pages/terms';
import OtpSubmit from 'granite-admin/pages/otpSubmit';
import WelcomeUser from 'granite-admin/pages/welcomeUser';
import IframeComponent from 'granite-admin/core/components/IframeComponent';
import BackToBoard from 'granite-admin/core/components/BackToBoard';
import Logout from 'granite-admin/core/components/Logout';
import SsoLogout from 'granite-admin/core/components/SsoLogout';
const Dashboard = /*#__PURE__*/lazy(() => import('granite-admin/pages/dashboard'));
const ProfilePage = /*#__PURE__*/lazy(() => import('granite-admin/pages/profile'));
const Basic = /*#__PURE__*/lazy(() => import('granite-admin/pages/companySettings/components/Basic'));
const Contact = /*#__PURE__*/lazy(() => import('granite-admin/pages/companySettings/components/Contact'));
const Settings = /*#__PURE__*/lazy(() => import('granite-admin/pages/companySettings/components/Settings'));
const ThemeConfigs = /*#__PURE__*/lazy(() => import('granite-admin/pages/themeConfigs'));
const Roles = /*#__PURE__*/lazy(() => import('granite-admin/pages/roles'));
const permissionGrpMgt = /*#__PURE__*/lazy(() => import('granite-admin/pages/permissionGrpMgt'));
const TransitionMasterList = /*#__PURE__*/lazy(() => import('granite-admin/pages/transitionMasterList'));
const TransitionMasterEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/transitionMasterEdit'));
const TransitionList = /*#__PURE__*/lazy(() => import('granite-admin/pages/transitionList'));
const TransitionEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/transitionEdit'));
const ApiDocs = /*#__PURE__*/lazy(() => import('granite-admin/pages/apiDocs'));
const ConfigsList = /*#__PURE__*/lazy(() => import('granite-admin/pages/configsList'));
const ConfigsEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/configsEdit'));
const WidgetsList = /*#__PURE__*/lazy(() => import('granite-admin/pages/widgetsList'));
const WidgetsEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/widgetsEdit'));
const NotificationTemplateList = /*#__PURE__*/lazy(() => import('granite-admin/pages/notificationTemplateList'));
const NotificationTemplateListEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/notificationTemplateEdit'));
const NewTab = /*#__PURE__*/lazy(() => import('granite-admin/pages/newTab'));
const StatusList = /*#__PURE__*/lazy(() => import('granite-admin/pages/statusList'));
const StatusEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/statusEdit'));
const ReportsList = /*#__PURE__*/lazy(() => import('granite-admin/pages/reportsList'));
const WorkFlow = /*#__PURE__*/lazy(() => import('granite-admin/pages/workFlow'));
const WorkFlowList = /*#__PURE__*/lazy(() => import('granite-admin/pages/workFlowList'));
const AddDashboard = /*#__PURE__*/lazy(() => import('granite-admin/pages/addDashboard'));
const DashboardList = /*#__PURE__*/lazy(() => import('granite-admin/pages/dashboardList'));
const BusinessBoard = /*#__PURE__*/lazy(() => import('granite-admin/pages/dashboard/businessBoard'));
const MyBoard = /*#__PURE__*/lazy(() => import('granite-admin/pages/dashboard/myBoardV2'));
const TaskMasterList = /*#__PURE__*/lazy(() => import('granite-admin/pages/taskMasterList'));
const TaskMasterEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/taskMasterEdit'));
const RulesManagement = /*#__PURE__*/lazy(() => import('granite-admin/pages/rulesManagement'));
const BusinessAdminList = /*#__PURE__*/lazy(() => import('granite-admin/pages/businessAdminList'));
const BusinessAdminEdit = /*#__PURE__*/lazy(() => import('granite-admin/pages/businessAdminEdit'));
const NotificationLogs = /*#__PURE__*/lazy(() => import('granite-admin/pages/notificationLogs'));
const BusinessAdminRoles = /*#__PURE__*/lazy(() => import('granite-admin/pages/businessAdminRoles'));
const SideMenuControl = /*#__PURE__*/lazy(() => import('granite-admin/pages/sideMenuControl'));
const WorkFlowEditV2 = /*#__PURE__*/lazy(() => import('granite-admin/pages/workFlowEditV2'));
const WorkFlowListV2 = /*#__PURE__*/lazy(() => import('granite-admin/pages/workFlowListV2'));
const TransitionMasterListV2 = /*#__PURE__*/lazy(() => import('granite-admin/pages/transitionMasterListV2'));
const AthenaQueriesList = /*#__PURE__*/lazy(() => import('granite-admin/pages/athenaqueriesList'));
const AthenaQueriesForm = /*#__PURE__*/lazy(() => import('granite-admin/pages/athenaqueriesForm'));
const MagicForm = /*#__PURE__*/lazy(() => import('granite-admin/pages/queryMagicForm'));
const SaasBilling = /*#__PURE__*/lazy(() => import('granite-admin/pages/saasBilling'));
const CurrentPlan = /*#__PURE__*/lazy(() => import('granite-admin/pages/saasBilling/components/CurrentPlan'));
const PlanList = /*#__PURE__*/lazy(() => import('granite-admin/pages/planList'));
const FeatureList = /*#__PURE__*/lazy(() => import('granite-admin/pages/featureList'));
const PlanFeatures = /*#__PURE__*/lazy(() => import('granite-admin/pages/planFeatures'));
const RateList = /*#__PURE__*/lazy(() => import('granite-admin/pages/rateList'));
const AddRate = /*#__PURE__*/lazy(() => import('granite-admin/pages/addRate'));
const InvoicesPayments = /*#__PURE__*/lazy(() => import('granite-admin/pages/invoicesPayments'));
export default [{
  path: '/terms',
  exact: true,
  component: Terms,
  layout: 'HeaderLayout'
}, {
  path: '/company-settings',
  private: true,
  // component: CompanySettings,
  layout: 'DashboardLayout',
  tabs: [{
    content: /*#__PURE__*/React.createElement(Basic, null),
    title: 'Basic',
    path: 'basic',
    icon: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    content: /*#__PURE__*/React.createElement(Contact, null),
    title: 'Contact Information',
    path: 'contact',
    icon: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    content: /*#__PURE__*/React.createElement(Settings, null),
    title: 'Settings',
    path: 'settings',
    icon: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, {
    content: /*#__PURE__*/React.createElement(ThemeConfigs, null),
    title: 'Theme & Configs',
    path: 'theme-configs',
    icon: /*#__PURE__*/React.createElement(React.Fragment, null)
  }],
  breadcrumbPath: [{
    label: 'Settings'
  }, {
    label: 'Company Settings'
  }],
  heading: {
    title: 'Company Settings',
    subTitle: 'Edit & update your Company Settings'
  }
}, {
  path: '/login',
  exact: true,
  publicOnly: true,
  component: Login,
  layout: 'HeaderLayout'
}, {
  path: '/sso',
  exact: true,
  publicOnly: true,
  component: Sso,
  layout: 'HeaderLayout'
}, {
  path: '/register',
  exact: true,
  publicOnly: true,
  component: Register,
  layout: 'HeaderLayout'
}, {
  path: '/forgot-password',
  exact: true,
  publicOnly: true,
  component: ForgetPassword,
  layout: 'HeaderLayout'
}, {
  path: '/welcome-user',
  exact: true,
  publicOnly: true,
  component: WelcomeUser,
  layout: 'HeaderLayout'
}, {
  path: '/verify-account',
  exact: true,
  // TODO: change it to private
  private: true,
  component: VerifyAccount,
  layout: 'HeaderLayout'
}, {
  path: '/dashboard',
  exact: true,
  private: true,
  component: Dashboard,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Dashboard'
  }],
  heading: {
    title: 'Dashboard',
    subTitle: 'View summary of the system'
  }
}, {
  path: '/business-board/',
  exact: true,
  private: true,
  component: BusinessBoard,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Organizations List'
  }],
  heading: {
    title: 'Organizations List',
    subTitle: 'My sub organizations'
  }
}, {
  path: '/my-boards/:id/:name/',
  exact: true,
  private: true,
  component: MyBoard,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Dashboard'
  }, {
    label: ':name'
  }],
  heading: {
    title: 'Dashboard',
    subTitle: 'View summary of the system'
  }
}, {
  path: '/get-started',
  exact: true,
  private: true,
  component: OnBoarding,
  layout: 'LinearLayout'
}, {
  path: '/profile',
  private: true,
  component: ProfilePage,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Main'
  }, {
    label: 'Profile',
    path: '/profile'
  }],
  heading: {
    title: 'Edit User Profile',
    subTitle: 'Edit & update your Profile details'
  }
}, {
  path: '/transitions-master',
  exact: true,
  private: true,
  component: TransitionMasterList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Transitions'
  }],
  heading: {
    title: 'Transitions',
    subTitle: 'View & manage all your Transitions'
  }
}, {
  path: '/transitions-master/:id',
  private: true,
  component: TransitionMasterEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Transitions',
    path: '/transitions-master'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Transitions',
    subTitle: 'Create/Update Transition'
  }
  // permissions: ['transitions_update'],
}, {
  path: '/transitions-master-v2',
  exact: true,
  private: true,
  component: TransitionMasterListV2,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Transitions'
  }],
  heading: {
    title: 'Transitions',
    subTitle: 'View & manage all your Transition'
  }
}, {
  path: '/transitions',
  exact: true,
  private: true,
  component: TransitionList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Transitions'
  }],
  heading: {
    title: 'Transitions',
    subTitle: 'View & manage all your Transitions'
  }
}, {
  path: '/transitions/:id',
  private: true,
  component: TransitionEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Transition',
    path: '/transitions'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Transition',
    subTitle: 'Create/Update Transition'
  },
  permissions: ['transitions_update']
}, {
  path: '/privacy-policy',
  exact: true,
  public: true,
  component: PrivacyPolicy,
  layout: 'HeaderLayout'
}, {
  path: '/roles',
  private: true,
  component: Roles,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Roles',
    path: '/roles'
  }],
  heading: {
    title: 'Roles and Permissions',
    subTitle: 'Create & Manage roles and their permissions'
  }
}, {
  path: '/permission-group',
  private: true,
  component: permissionGrpMgt,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Permissions',
    path: '/permission-group'
  }],
  heading: {
    title: 'Permissions',
    subTitle: 'Create & Manage Permission'
  }
}, {
  path: '/api/:module/',
  private: true,
  exact: true,
  component: ApiDocs,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Api'
  }, {
    label: ':module'
  }],
  heading: {
    title: 'Granite Api Documents',
    subTitle: 'View Granite Api'
  }
}, {
  path: '/master-config/list/:config',
  private: true,
  exact: true,
  component: ConfigsList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Configs'
  }, {
    label: ':config'
  }],
  heading: {
    title: 'Master Config',
    subTitle: 'View and Manage Configs'
  }
}, {
  path: '/master-config/list/:config/:id',
  private: true,
  exact: true,
  component: ConfigsEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Master Configs',
    path: '/master-config/list/user-preference'
  }, {
    label: ':config'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Master Config',
    subTitle: 'Add/Edit Configs'
  },
  permissions: ['master-config_update']
}, {
  path: '/otp-submit',
  exact: true,
  publicOnly: true,
  component: OtpSubmit,
  layout: 'HeaderLayout'
}, {
  path: '/master-widgets',
  private: true,
  exact: true,
  component: WidgetsList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Widgets'
  }],
  heading: {
    title: 'Master Widgets',
    subTitle: 'View and Manage Widgets'
  }
}, {
  path: '/master-widgets/:id',
  private: true,
  exact: true,
  component: WidgetsEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Master Widgets',
    path: '/master-widgets'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Master Widgets',
    subTitle: 'Add/Edit Widgets'
  },
  permissions: ['master-widgets_update']
}, {
  path: '/notification-templates',
  exact: true,
  private: true,
  component: NotificationTemplateList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Notification Templates'
  }],
  heading: {
    title: 'Notifications Templates',
    subTitle: 'View & manage all your Notifications Templates'
  }
}, {
  path: '/notification-templates/:id',
  private: true,
  component: NotificationTemplateListEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Notifications Templates',
    path: '/notification-templates'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Notifications Template',
    subTitle: 'Create/Update Notifications Template'
  },
  permissions: ['notification-templates_update']
}, {
  path: '/new-tab',
  private: true,
  component: NewTab,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'New Tab',
    path: '/new-tab'
  }],
  heading: {
    title: 'New Tab',
    subTitle: 'Admin Workspace'
  }
}, {
  path: '/master-status',
  private: true,
  exact: true,
  component: StatusList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'States'
  }],
  heading: {
    title: 'States',
    subTitle: 'View and Manage State'
  }
}, {
  path: '/master-status/:id',
  private: true,
  exact: true,
  component: StatusEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'States',
    path: '/master-status'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'States',
    subTitle: 'Add/Edit State'
  },
  permissions: ['master-status_update']
}, {
  path: '/reports/list',
  private: true,
  component: ReportsList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Reports'
  }],
  heading: {
    title: 'Reports',
    subTitle: 'Manage reports'
  }
}, {
  path: '/workflow/:id',
  private: true,
  exact: true,
  component: WorkFlow,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'WorkFlow',
    path: '/workflow/'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'WorkFlow',
    subTitle: 'Manage Workflow'
  }
}, {
  path: '/workflow',
  exact: true,
  private: true,
  component: WorkFlowList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'WorkFlow'
  }],
  heading: {
    title: 'WorkFlow',
    subTitle: 'View & manage all your WorkFlows'
  }
}, {
  path: '/workflowV2/:id',
  private: true,
  exact: true,
  component: WorkFlowEditV2,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Workflows',
    path: '/workflowV2'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Workflows',
    subTitle: 'Create/Edit Workflow'
  }
}, {
  path: '/workflowV2',
  exact: true,
  private: true,
  component: WorkFlowListV2,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Workflows'
  }],
  heading: {
    title: 'Workflows',
    subTitle: 'View & manage all your Workflows'
  }
}, {
  path: '/dashboards/:id',
  exact: true,
  private: true,
  component: AddDashboard,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Dashboard',
    path: '/dashboards'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Dashboard',
    subTitle: 'Create new Dashboard'
  }
}, {
  path: '/dashboards/',
  exact: true,
  private: true,
  component: DashboardList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Dashboard'
  }],
  heading: {
    title: 'Dashboard',
    subTitle: 'Create new Dashboard'
  }
}, {
  path: '/task-management',
  exact: true,
  private: true,
  component: TaskMasterList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Tasks'
  }],
  heading: {
    title: 'Tasks',
    subTitle: 'View and edit all the tasks'
  }
}, {
  path: '/task-management/:id',
  private: true,
  component: TaskMasterEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Tasks',
    path: '/task-management'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Tasks'
  }
  // permissions: ['business_admin_write', 'task_master_write'],
}, {
  path: '/embed',
  private: true,
  exact: true,
  component: IframeComponent,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Embedded Dashboard'
  }],
  heading: {
    title: 'Embedded Dashboard',
    subTitle: 'View embedded dashboard'
  }
}, {
  path: '/rules-management',
  private: true,
  component: RulesManagement,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Business Rules',
    path: '/rules-management'
  }],
  entityName: 'common_ruleset',
  fields: ['rule_result'],
  heading: {
    title: 'Business Rules',
    subTitle: 'View and manage scoring rules'
  }
  // permissions: ['business_admin_write', 'task_master_write'],
}, {
  path: '/business-admins',
  exact: true,
  private: true,
  component: BusinessAdminList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Users'
  }],
  heading: {
    title: 'Users',
    subTitle: 'View & manage all your users'
  }
}, {
  path: '/business-admins/:id',
  private: true,
  component: BusinessAdminEdit,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Users',
    path: '/business-admins'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Users',
    subTitle: 'Add/Edit user'
  }
}, {
  path: '/back-to-board',
  private: true,
  component: BackToBoard,
  layout: 'DashboardLayout'
}, {
  path: '/logout',
  private: true,
  component: Logout,
  noSidebar: true,
  shouldFetchHelpTexts: false,
  shouldFetchPermissions: false
}, {
  path: '/sso-logout',
  private: true,
  component: SsoLogout,
  noSidebar: true,
  shouldFetchHelpTexts: false,
  shouldFetchPermissions: false
}, {
  path: '/notificationLogs',
  exact: true,
  private: true,
  component: NotificationLogs,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Notification Logs'
  }],
  heading: {
    title: 'Notification  Logs',
    subTitle: 'View all notification logs'
  }
}, {
  path: '/business-admin-roles',
  exact: true,
  private: true,
  component: BusinessAdminRoles,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Roles'
  }],
  heading: {
    title: 'Roles',
    subTitle: 'View and manage Roles'
  }
}, {
  path: '/sidemenu-control',
  exact: true,
  private: true,
  component: SideMenuControl,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Side Menu Access'
  }],
  heading: {
    title: 'Side Menu Access',
    subTitle: 'View & manage all the Side Menus'
  }
}, {
  path: '/queries/list',
  private: true,
  exact: true,
  component: AthenaQueriesList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Queries'
  }],
  heading: {
    title: 'Queries',
    subTitle: 'All the queries created will be shown here'
  }
}, {
  path: '/queries/detail/:id',
  private: true,
  exact: true,
  component: AthenaQueriesForm,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Queries',
    path: '/queries/list'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Queries Form',
    subTitle: 'Create or Edit queries'
  }
}, {
  path: '/query-editor/:id',
  private: true,
  exact: true,
  component: MagicForm,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Queries',
    path: '/queries/list'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Query Form',
    subTitle: 'Create or Edit queries'
  }
}, {
  path: '/business-admin-theme',
  exact: true,
  private: true,
  component: ThemeConfigs,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Themes'
  }],
  heading: {
    title: 'Themes',
    subTitle: 'View & manage theme & configurations'
  }
}, {
  path: '/billing',
  exact: true,
  private: true,
  component: SaasBilling,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Billing and Subscription'
  }],
  heading: {
    title: 'Billing and Subscription',
    subTitle: 'Select your billing plan'
  },
  shouldFetchPermissions: false,
  shouldFetchHelpTexts: false
}, {
  path: '/billing/my-plan',
  private: true,
  component: CurrentPlan,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Billing and Subscription'
  }],
  heading: {
    title: 'Billing and Subscription',
    subTitle: 'Manage your Subscription'
  },
  shouldFetchPermissions: false,
  shouldFetchHelpTexts: false
}, {
  path: '/plans',
  exact: true,
  private: true,
  component: PlanList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Billing Plans'
  }],
  heading: {
    title: 'Plans',
    subTitle: 'Create plans.'
  }
}, {
  path: '/features',
  exact: true,
  private: true,
  component: FeatureList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Feature List'
  }],
  heading: {
    title: 'Features',
    subTitle: 'Create Features.'
  }
}, {
  path: '/plan-features',
  exact: true,
  private: true,
  component: PlanFeatures,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Plan Features'
  }],
  heading: {
    title: 'Plan Features',
    subTitle: 'Map features to plans.'
  }
}, {
  path: '/rates',
  exact: true,
  private: true,
  component: RateList,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Usage Rates'
  }],
  heading: {
    title: 'Usage Rates',
    subTitle: 'List of Usage Rates for plans.'
  }
}, {
  path: '/rates/:id',
  exact: true,
  private: true,
  component: AddRate,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Usage Rates',
    path: '/rates'
  }, {
    label: ':id'
  }],
  heading: {
    title: 'Usage Rates',
    subTitle: 'Manage Usage Rates for plans.'
  }
}, {
  path: '/invoices',
  exact: true,
  private: true,
  component: InvoicesPayments,
  layout: 'DashboardLayout',
  breadcrumbPath: [{
    label: 'Invoices & Payments'
  }],
  heading: {
    title: 'Invoices & Payments',
    subTitle: 'Manage Invoices & Payments'
  }
}];